interface SortOrderIconProps {
  size?: number;
  direction: 'up' | 'down';
}

type Point = [number, number];

const BASE_ARROW_POINTS: Point[] = [
  [32, 8],   // tip
  [20, 24],  // head left
  [27, 24],  // neck left
  [23, 52],  // tail left
  [41, 52],  // tail right
  [37, 24],  // neck right
  [44, 24],  // head right
];

const BASE_ARROW_POINTS_DOWN: Point[] = [
  [32, 56],  // tip
  [20, 40],  // head left
  [27, 40],  // neck left
  [29, 12],  // tail left
  [35, 12],  // tail right
  [37, 40],  // neck right
  [44, 40],  // head right
];

const projectGroundPerspective = (
  points: Point[],
  topScale = 0.62,
  bottomScale = 1.08,
  centerX = 32,
): Point[] => {
  return points.map(([x, y]) => {
    const t = y / 64;
    const scale = topScale + (bottomScale - topScale) * t;
    return [centerX + (x - centerX) * scale, y];
  });
};

const pointsToPath = (points: Point[]): string =>
  points.map(([x, y], idx) => `${idx === 0 ? 'M' : 'L'} ${x} ${y}`).join(' ') + ' Z';

const SortOrderIcon: React.FC<SortOrderIconProps> = ({ size = 24, direction }) => {
  const directionalPoints = direction === 'down' ? BASE_ARROW_POINTS_DOWN : BASE_ARROW_POINTS;
  const pathD = pointsToPath(projectGroundPerspective(directionalPoints));
  const flattenedTransform = 'translate(0 22) scale(1 0.35)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="16 22 32 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
    >
      <g transform={flattenedTransform}>
        <path d={pathD} fill="currentColor" />
      </g>
    </svg>
  );
};

export default SortOrderIcon;
